import { useEffect, useState } from 'react'

import { makeNotifications } from '../../main/usecases/notifications/remote-notifications-factory'

import { get } from '../helpers/helper-storage'

const useNotificationPolling = () => {
  const [hasNewNotification, setHasNewNotification] = useState(false)

  const authority = get('authority')

  let numberOfElements = 0

  let firstRequest = true

  useEffect(() => {
    const fetchNotifications = async () => {
      const response = await makeNotifications().load({
        type: authority,
      })

      if (firstRequest) {
        numberOfElements = response.numberOfElements
        firstRequest = false
      }

      if (response.numberOfElements > numberOfElements && !firstRequest) {
        setHasNewNotification(true)
      }
    }

    const intervalId = setInterval(fetchNotifications, 10000)

    return () => clearInterval(intervalId)
  }, [])

  return hasNewNotification
}

export default useNotificationPolling
